/**
 * FSD Part 14 — Asset Management: the company's own operational asset
 * register (distinct from Service's customer assets and from Finance's
 * fixed-asset register). C17: one section per FSD feature specification
 * (14.2.1 AST-F01 … 14.2.8 AST-F08) that has a screen.
 *
 * Item ids are stable: favourites and recents (localStorage) key off them, so
 * an item may move between sections but its id never changes.
 */
import type { NavGroup } from '../types'
import { EAM_PERMISSIONS } from '@/modules/eam/permissions'

export const P14_EAM_GROUPS: NavGroup[] = [
  {
    id: 's-14.2.1',
    kind: 'feature',
    fsd: '14.2.1',
    code: 'AST-F01',
    labelKey: 'nav.fsd.s14_2_1.short',
    fullTitleKey: 'nav.fsd.s14_2_1.full',
    items: [
      {
        id: 'eam-assets',
        labelKey: 'eam.routeTitles.assets',
        to: '/eam/assets',
        icon: 'monitor',
        permission: EAM_PERMISSIONS.assetRead,
        keywordsKey: 'nav.items.eamAssets.keywords',
        descriptionKey: 'nav.items.eamAssets.description',
      },
      {
        id: 'eam-locations',
        labelKey: 'eam.routeTitles.locations',
        to: '/eam/locations',
        icon: 'mapPin',
        permission: EAM_PERMISSIONS.assetRead,
        keywordsKey: 'nav.items.eamLocations.keywords',
        descriptionKey: 'nav.items.eamLocations.description',
      },
      {
        id: 'eam-reconciliation',
        labelKey: 'eam.routeTitles.reconciliation',
        to: '/eam/assets/reconciliation',
        icon: 'history',
        permission: EAM_PERMISSIONS.reportRead,
        keywordsKey: 'nav.items.eamReconciliation.keywords',
        descriptionKey: 'nav.items.eamReconciliation.description',
      },
    ],
  },
  {
    id: 's-14.2.3',
    kind: 'feature',
    fsd: '14.2.3',
    code: 'AST-F03',
    labelKey: 'nav.fsd.s14_2_3.short',
    fullTitleKey: 'nav.fsd.s14_2_3.full',
    items: [
      {
        id: 'eam-maintenance',
        labelKey: 'eam.routeTitles.maintenance',
        to: '/eam/maintenance',
        icon: 'refresh',
        permission: EAM_PERMISSIONS.planRead,
        keywordsKey: 'nav.items.eamMaintenance.keywords',
        descriptionKey: 'nav.items.eamMaintenance.description',
      },
    ],
  },
  {
    id: 's-14.2.4',
    kind: 'feature',
    fsd: '14.2.4',
    code: 'AST-F04',
    labelKey: 'nav.fsd.s14_2_4.short',
    fullTitleKey: 'nav.fsd.s14_2_4.full',
    items: [
      {
        id: 'eam-meters',
        labelKey: 'eam.routeTitles.meters',
        to: '/eam/meters',
        icon: 'scale',
        permission: EAM_PERMISSIONS.meterRead,
        keywordsKey: 'nav.items.eamMeters.keywords',
        descriptionKey: 'nav.items.eamMeters.description',
      },
    ],
  },
  {
    id: 's-14.2.5',
    kind: 'feature',
    fsd: '14.2.5',
    code: 'AST-F05',
    labelKey: 'nav.fsd.s14_2_5.short',
    fullTitleKey: 'nav.fsd.s14_2_5.full',
    items: [
      {
        id: 'eam-permits',
        labelKey: 'eam.routeTitles.permits',
        to: '/eam/permits',
        icon: 'key',
        permission: EAM_PERMISSIONS.permitRead,
        keywordsKey: 'nav.items.eamPermits.keywords',
        descriptionKey: 'nav.items.eamPermits.description',
      },
      {
        id: 'eam-downtime',
        labelKey: 'eam.routeTitles.downtime',
        to: '/eam/downtime',
        icon: 'clock',
        permission: EAM_PERMISSIONS.assetRead,
        keywordsKey: 'nav.items.eamDowntime.keywords',
        descriptionKey: 'nav.items.eamDowntime.description',
      },
    ],
  },
  {
    id: 's-14.2.6',
    kind: 'feature',
    fsd: '14.2.6',
    code: 'AST-F06',
    labelKey: 'nav.fsd.s14_2_6.short',
    fullTitleKey: 'nav.fsd.s14_2_6.full',
    items: [
      {
        id: 'eam-failures',
        labelKey: 'eam.routeTitles.failures',
        to: '/eam/failures',
        icon: 'alert',
        permission: EAM_PERMISSIONS.assetRead,
        keywordsKey: 'nav.items.eamFailures.keywords',
        descriptionKey: 'nav.items.eamFailures.description',
      },
    ],
  },
  {
    id: 's-14.2.8',
    kind: 'feature',
    fsd: '14.2.8',
    code: 'AST-F08',
    labelKey: 'nav.fsd.s14_2_8.short',
    fullTitleKey: 'nav.fsd.s14_2_8.full',
    items: [
      {
        id: 'eam-compliance',
        labelKey: 'eam.routeTitles.compliance',
        to: '/eam/compliance',
        icon: 'shield',
        permission: EAM_PERMISSIONS.complianceRead,
        keywordsKey: 'nav.items.eamCompliance.keywords',
        descriptionKey: 'nav.items.eamCompliance.description',
      },
    ],
  },
]
